module.exports = __webpack_public_path__ + "img/frame (18).3aa9e5a1.jpg";